import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError, filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { currentContextVersion } from './tab-session';

/**
 * Drops the response of an API request when this tab switched organization (or signed out) while it was in flight,
 * so a slow answer for the previous organization can never fill the screen of the current one. Translation files and
 * other non-API requests pass through untouched.
 */
@Injectable()
export class ContextInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!isApiRequest(req.url)) {
            return next.handle(req);
        }
        const version = currentContextVersion();
        const isCurrent = () => currentContextVersion() === version;
        return next.handle(req).pipe(
            filter(isCurrent),
            catchError((err) => (isCurrent() ? throwError(err) : EMPTY))
        );
    }
}

function isApiRequest(url: string): boolean {
    return [environment.BASEAPI, environment.PARTNERAPI].some((base) => !!base && url.startsWith(base));
}
